import { Children } from "react";
import Link from '@mui/material/Link';
import { Breadcrumbs, Typography } from "@mui/material"

import { IBreadCrumbData } from "../../types/components/breadcrump.types";
import { theme } from "../../utils";

interface IBreadCrumbProps {
    breadCrumbPath: IBreadCrumbData[];
    sx?: any;
    linkSx?: any;
}

export const BreadCrumb = (props: IBreadCrumbProps) => {
    const { breadCrumbPath, sx ,linkSx} = props

    const activeIndex = breadCrumbPath?.length - 1

    return (
        <Breadcrumbs aria-label="breadcrumb" sx={{...linkSx}}>
            {Children.toArray(
                breadCrumbPath.map((i, index) => {
                    if (index === activeIndex) {
                        return (
                            <Typography aria-current="page" sx={{ ...theme.typography.components.breadcrump, ...sx, fontWeight: 700 }}>
                                {i.name}
                            </Typography>
                        )
                    }
                    return (
                        <Link underline="hover" color="inherit" href={i.url} sx={{...linkSx}}>
                            <Typography sx={{ ...theme.typography.components.breadcrump, ...sx, fontWeight: 400 }}>
                                {i.name}
                            </Typography>
                        </Link>
                    )
                })
            )}
        </Breadcrumbs>
    )
}